import * as defaultIcons from '@schibsted/icons';
import type { StreamProvider } from '@vgtv/api-client';
import { useEffect, useState } from 'preact/hooks';
import type { Theme } from '../../../config/vendorToDnaBrand';
import { resolveDnaStyleOption } from '../../../config/vendorToDnaBrand';
import { usePlayer } from './PlayerProvider';
import { useConfig } from './ConfigProvider';

type IconModule = typeof defaultIcons;

const getIconModuleForTheme = async (theme: Theme): Promise<IconModule> => {
  switch (theme) {
    case 'vg':
      return import('@schibsted/icons/vg');
    case 'e24':
      return import('@schibsted/icons/e24');
    case 'ab':
      return import('@schibsted/icons/ab');
    case 'bt':
      return import('@schibsted/icons/bt');
    case 'ap':
      return import('@schibsted/icons/ap');
    case 'sa':
      return import('@schibsted/icons/sa');
    case 'svd':
      return import('@schibsted/icons/svd');
    case 'tek':
      return import('@schibsted/icons/tek');
  }
};

export function useIcons(): IconModule {
  const [icons, setIcons] = useState<IconModule>(defaultIcons);
  const player = usePlayer();
  const { dnaStyle } = useConfig();
  const theme = resolveDnaStyleOption(
    player.getRawConfig().vendor as StreamProvider,
    dnaStyle
  );

  useEffect(() => {
    getIconModuleForTheme(theme).then(setIcons);
  }, [theme]);

  return icons;
}
